import React from "react";
import { useNavigate } from "react-router-dom";

export const AguardandoEmpresa = () => {
  const navigate = useNavigate();
  let isEstudanteAqui = false;
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    isEstudanteAqui = Number(u?.acesso_autorizacao ?? 0) === 1;
  } catch (_) {
    isEstudanteAqui = false;
  }

  const recarregarLogin = () => {
    try {
      window.localStorage.clear();
      window.sessionStorage.clear();
    } catch (_) {}
    navigate("/", { replace: true });
  };

  const titulo = isEstudanteAqui
    ? "Nenhuma autorização vinculada"
    : "Aguardando Empresa";

  const mensagem = isEstudanteAqui ? (
    <>
      Não localizamos uma autorização ativa vinculada ao seu CPF nesta
      sessão.
      <br />
      <br />
      Faça login novamente para carregar sua autorização. Se o problema
      persistir, entre em contato com o CIEEMG.
    </>
  ) : (
    <>
      Você ainda não tem um TCE para preencher.
      <br />
      <br />
      A empresa precisa criar o TCE primeiro. Depois você poderá abrir
      aqui e preencher seus dados.
    </>
  );

  return (
    <div className="tce-container tce-py-5 tce-text-center">
      <h2 className="tce-h2">{titulo}</h2>
      <p
        className="tce-text-muted"
        style={{ maxWidth: "500px", margin: "1rem auto" }}
      >
        {mensagem}
      </p>

      <button
        type="button"
        className={
          isEstudanteAqui
            ? "tce-btn tce-btn-primary"
            : "tce-btn tce-btn-secondary"
        }
        onClick={isEstudanteAqui ? recarregarLogin : () => navigate("/")}
        style={{ marginTop: "1rem" }}
      >
        {isEstudanteAqui ? "Fazer login novamente" : "Voltar"}
      </button>
    </div>
  );
};

export default AguardandoEmpresa;
